import { render, staticRenderFns } from "./RoomDetail.vue?vue&type=template&id=180914d1&scoped=true&"
import script from "./RoomDetail.vue?vue&type=script&lang=js&"
export * from "./RoomDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180914d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180914d1')) {
      api.createRecord('180914d1', component.options)
    } else {
      api.reload('180914d1', component.options)
    }
    module.hot.accept("./RoomDetail.vue?vue&type=template&id=180914d1&scoped=true&", function () {
      api.rerender('180914d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/cruise/room/RoomDetail.vue"
export default component.exports